import React, {useEffect, useState} from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import {apollo_useStyles, getMenuDialogStyle, Option, platformPathMaster} from "../atom/Apollo_styles";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions/CardActions";
import {ApolloMessage} from "../atom/Apollo_Mesasge";
import {useHistory} from "react-router-dom";
import {Grid} from "@material-ui/core";
import {apollo_account_platform_menu_path} from "../atom/Apollo_links";
import classNames from "classnames";
import {apimessageMap, ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../atom/Apollo_ApiRequest3";
import {ApolloContext} from "../atom/Apollo_Context";
import {ApolloDialog} from "../atom/Apollo_Dialog";

const animatedComponents = makeAnimated();

export function SelectMenu(props: { pathTop: string, pathEnd: string, open: boolean, setOpen: any}) {
  const history = useHistory();
  const classes = apollo_useStyles();
  const {state} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [dialogStyle] = React.useState(getMenuDialogStyle);
  const cardActionClass = classNames(classes.cardaction, classes.cardActionButton);
  const {pathTop, pathEnd, open, setOpen} = props;
  const [menuId, setMenuId] = useState(0);
  const [menu, setMenu] = useState<Option[]>([]);
  const [pfAccountIdList, setPfAccountIdList] = useState<string[]>([]);
  const accountGroupId = state.current.accountGroupId;
  const accountId = state.current.accountId;

  const handleSubmit = () => {
    const path = `${pathTop}${platformPathMaster[menuId]}/${accountGroupId}/${accountId}/${pfAccountIdList[menuId]}`
    const reload = history.location.pathname === path;
    history.push(`${path}${pathEnd}`);
    if(reload) window.location.reload();
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  }

  useEffect(() => {
    if (!open) return;
    const options: Option[] = [];
    const path = apollo_account_platform_menu_path + "/" + accountId;
    ApolloAxios.get(path).then(response => {
      const res: ApiResponse = response.data
      if (!isSuccessApi(res.resultCode)) {
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : apimessageMap[14].msg,
        });
      }

      const pfIdList: string[] = [];
      res.result?.map((menuData: { menuId: number, menuName: string, useStatus: number, campaignKindId: number, pfAccountId: string }) => {
        if (menuData.campaignKindId !== 0 || !(menuData.useStatus === 1 || menuData.useStatus === 5)) return;
        const option: Option = {
          value: menuData.menuId,
          label: menuData.menuName,
        }
        options.push(option);
        pfIdList[menuData.menuId] = menuData.pfAccountId ? menuData.pfAccountId : "0";
      });
      setMenu(options);
      setPfAccountIdList(pfIdList);

      // 利用可能なメニューが存在しない場合
      if (options.length === 0) {
        return Promise.reject({
          open: true,
          type: getResultType(2),
          errmsg: apimessageMap[15].msg,
        });
      }
    }).catch(err => {
      handleClose();
      setmsg({
        type: "all",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });
  }, [open]);

  return (
    <React.Fragment>
      <ApolloDialog open={open} setOpen={setOpen}>
        <Grid style={dialogStyle}>
          <DialogTitle id="alert-dialog-title">表示メニューを選択</DialogTitle>
          <Grid className={classes.selectInModal}>
            <Select
              id="menu"
              name="menu"
              components={animatedComponents}
              key={menu ? "Loaded" : "Loading"}
              defaultValue={menu[0]}
              options={menu}
              onChange={(e: any) => setMenuId(e.value)}
            />
          </Grid>
          <CardActions className={cardActionClass}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              className={classes.button}
              disabled={menuId === 0}
            >
              選択したメニューを表示
            </Button>
            <Button
              variant="contained"
              color="default"
              onClick={handleClose}
              className={classes.button}
            >
              キャンセル
            </Button>
          </CardActions>
        </Grid>
      </ApolloDialog>
    </React.Fragment>
  );
}

export interface IsSelectableMenuProps {
  adClientIconFlg: boolean,
  setAdClientIconFlg: any,
  isDisplayErrMsg: boolean,
}
/** 広告主アイコン用 メニュー選択可能判断 */
export const IsAdClientIconSelectableMenu: React.FC<IsSelectableMenuProps> = ({adClientIconFlg, setAdClientIconFlg, isDisplayErrMsg, ...props}) => {

  const {state} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const accountId = state.current.accountId;

  React.useEffect(() => {
    const init = async() => {
      const options: Option[] = [];
      const path = apollo_account_platform_menu_path + "/" + accountId;
      await ApolloAxios.get(path).then(response => {
        const res: ApiResponse = response.data
        if (!isSuccessApi(res.resultCode)) {
          return;
        }

        res.result?.map((menuData: { menuId: number, menuName: string, useStatus: number, campaignKindId: number, pfAccountId: string }) => {
          if (menuData.campaignKindId !== 0 || !(menuData.useStatus === 1 || menuData.useStatus === 5)) return;
          const option: Option = {
            value: menuData.menuId,
            label: menuData.menuName,
          }
          options.push(option);
        });
      }).catch(err => {
        // なにもしない
      });

      let isOK = true;
      if (options.length === 0) {
        isOK = false;
      } else {
        if (options.filter(x => x.value === 2).length === 0) {
          isOK = false;
        } 
      }
      setAdClientIconFlg(isOK)

      if (isDisplayErrMsg) {
        if (!isOK) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: "画面遷移可能なメニュー(媒体)がありません"
            }
          });
          return;
        }
      }
    }
    init();
  }, []);

  return (
    <div>
      {
        adClientIconFlg ? props.children : ""
      }
    </div>
  )
}
